import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Header from "./components/comman/Header";
import Login from "./components/pages/Login";
import Register from "./components/pages/Register";
import ProductMaterial from "./components/pages/ProductMaterial";
import ProductList from "./components/pages/ProductList";
import Dashboard from "./components/operator/Dashboard";
import SeniorManagement from "./components/seniorManagement/SeniorManagement";
import InspectionDashboard from "./components/InspectionDashboard/InspectionDashboard";
import SupervisorDashboard from "./components/SupervisorDashboard/SupervisorDashboard";
import Management from "./components/management/Management";
import { ToastContainer } from "react-toastify";
import { ProductionProvider } from "./context/ProductionContext";
import ChatWidget from "./components/chatbot/ChatWidget";
// Admin Pages
import AdminLayout from "./components/admin/AdminLayout";
import Machine from "./components/admin/machine/Machine";
import Bom from "./components/admin/bom/Bom";
import Material from "./components/admin/material/Material";
import Product from "./components/admin/product/Product";
import Die from "./components/admin/die/die";
import Training from "./components/admin/training/Training";
import Attendance from "./components/admin/attendance/Attendance";
import Users from "./components/admin/users/Users";
import ProtectedRoute from "./components/ProtectedRoute";
import OperatorLogin from "./components/pages/OperatorLogin";
import Logproduction from "./components/degreser1/Logproductiondeg";
import LogsPage from "./components/admin/logspage/LogsPage";


function MainLayout() {
  const location = useLocation();
  const hideHeader =
    location.pathname === "/" ||
    location.pathname === "/login" ||
    location.pathname === "/register" ||
    location.pathname.startsWith("/admin");
  const hideChatbot = hideHeader;
  return (
    <>
      {!hideHeader && <Header />}
      {!hideChatbot && <ChatWidget />}
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<OperatorLogin />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/product-material" element={<ProductMaterial />} />
        <Route path="/productList" element={<ProductList />} />

        {/* Operator Dashboard */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={["operator"]}>
              <ProductionProvider>
                <Dashboard />
              </ProductionProvider>
            </ProtectedRoute>
          }
        />

        {/* Inspection Dashboard */}
        <Route
          path="/inspection-dashboard"
          element={
            <ProtectedRoute allowedRoles={["inspection"]}>
              <InspectionDashboard />
            </ProtectedRoute>
          }
        />

        {/* Supervisor Dashboard */}
        <Route
          path="/supervisor-dashboard"
          element={
            <ProtectedRoute allowedRoles={["supervisor"]}>
              <SupervisorDashboard />
            </ProtectedRoute>
          }
        />

        {/* Management Dashboard */}
        <Route
          path="/management-dashboard"
          element={
            <ProtectedRoute allowedRoles={["manager"]}>
              <Management />
            </ProtectedRoute>
          }
        />

        <Route
          path="/senior-management"
          element={
            <ProtectedRoute
              allowedRoles={["senior_manager"]}
              requiredPermission="SeniorManagement.view"
            >
              <SeniorManagement />
            </ProtectedRoute>
          }
        />
        {/* Desgreser */}
        <Route
          path="/desgreser"
          element={
            <Logproduction />
          }
        />
        {/* Admin Routes */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="machine" element={<Machine />} />
          <Route path="bom" element={<Bom />} />
          <Route path="material" element={<Material />} />
          <Route path="product" element={<Product />} />
          <Route path="die" element={<Die />} />
          <Route path="training" element={<Training />} />
          <Route path="attendance" element={<Attendance />} />
          <Route path="users" element={<Users />} />
          <Route path="logspage" element={<LogsPage />} />
        </Route>
        {/* Redirect all unknown routes to Login */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <MainLayout />
    </BrowserRouter>
  );
}

export default App;
